import styled from "@emotion/styled";
import {
  MediaQueries,
  Section as ComponentWarehouseSection,
  Spacings,
} from "@polestar/component-warehouse-react";

const Section = styled(ComponentWarehouseSection)`
  margin-top: ${Spacings.xxxLarge};
  margin-bottom: ${Spacings.xxxLarge};

  ${MediaQueries.desktop} {
    margin-top: ${Spacings.xxxxLarge};
    margin-bottom: ${Spacings.xxxxLarge};
  }
`;

export default Section;
